<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="prf">
<p class="nonindent"><a id="pageix"></a>Those who would give up essential liberty to purchase a little temporary safety deserve neither liberty nor safety.</p>
<p class="nonindent">—Benjamin Franklin (1759)</p>
<p class="extract">The only thing we have to fear is fear itself.</p>
<p class="nonindent">—Franklin D. Roosevelt (1932)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429954631_epub_prf_r1.vue?824961ee